<script lang="ts" setup>
	/**
	 * Bandeau hors connexion.
	 *
	 * L'application reste utilisable sans réseau — le socle est servi par le
	 * service worker — mais l'état d'une course, lui, peut être périmé. Le dire
	 * explicitement évite qu'un client patiente devant un statut figé.
	 */
	import { useI18n } from 'vue-i18n';
	import { useOnline } from '@common/composables';

	const { t } = useI18n();
	const online = useOnline();
</script>

<template>
	<v-slide-y-transition>
		<div v-if="!online" class="offline-banner">
			<v-icon size="20" class="mr-2">mdi-wifi-off</v-icon>
			<span class="font-weight-medium">{{ t('error.offline') }}</span>
			<span class="offline-banner_hint">{{ t('error.offlineHint') }}</span>
		</div>
	</v-slide-y-transition>
</template>

<style lang="scss">
	.offline-banner {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 2000;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		gap: 0 8px;
		padding: calc(6px + var(--app-safe-top, 0px)) 16px 6px;
		background: rgb(var(--v-theme-warning));
		color: #fff;
		font-size: 0.9rem;

		&_hint {
			opacity: 0.85;
			font-size: 0.82rem;
		}
	}
</style>
